import crypto from 'crypto-browserify';
import { migrationStagesOrder, migrationStages } from './defaultOptions';

export const getAssetType = (value) => {
    if (!value) {
        return null;
    }
    switch (value) {
    case 'application/x-shockwave-flash':
        return 'video';
    case 'application/doc':
    case 'application/ms-doc':
    case 'application/msword':
    case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
    case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
    case 'application/pdf':
    case 'application/epub+zip':
    case 'application/vnd.oasis.opendocument.presentation':
    case 'application/vnd.oasis.opendocument.spreadsheet':
    case 'application/vnd.oasis.opendocument.text':
    case 'application/vnd.ms-powerpoint':
    case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
    case 'application/rtf':
    case 'application/vnd.ms-excel':
    case 'application/xml':
        return 'document';
    default:
        break;
    }

    const array = value && value.split('/');

    return array[0];
};

export const getAssetTypeExtension = (value) => {
    if (!value) {
        return null;
    }

    const array = value.split('/');

    if (array && array.length && array[1]) {
        return array[1];
    }

    return null;
};

export const removeUnderScrolls = (value) => {
    return value && value.split('_').join(' ');
};

export const convertToCamelCase = (value) => {
    const object = {};
    if (Object.keys(value).length) {
        Object.keys(value).map((val) => {
            let string = val && val.split('_');
            if (string.length > 1) {
                string.map((str, index) => {
                    if (index > 0) {
                        string[index] = str.charAt(0).toUpperCase() + str.toLowerCase().slice(1);
                    }

                    return null;
                });

                string = string.join('');
            }

            let object2 = value[val];
            if (typeof (object2) === 'object' && !Array.isArray(object2)) {
                object2 = convertToCamelCase(object2);
            }
            object[string] = object2;

            return null;
        });

        return object;
    }
};

export const MsgTypes = (value, address) => {
    switch (value.type) {
    case 'MsgListNFT':
        return 'List NFT';
    case 'MsgMintONFT':
        return 'Mint NFT';
    case 'MsgBuyNFT':
        return 'Buy NFT';
    case 'MsgDeListNFT':
        return 'Delist NFT';
    case 'MsgBurnONFT':
        return 'Burn NFT';
    case 'MsgCreateDenom':
        return 'Mint Collection';
    case 'MsgTransferONFT':
        return 'Transfer NFT';
    case 'MsgSend':
        if (value.recipient && value.recipient === address) {
            return 'Received';
        } else {
            return 'Send';
        }
    case 'MsgSubmitProposal':
        return 'Submit Proposal';
    case 'MsgVote':
        return 'Vote';
    case 'MsgDelegate':
        return 'Delegate';
    case 'MsgCreateAuction':
        return 'Auction created';
    case 'MsgPlaceBid':
        return 'Bid Placed';
    case 'ProcessBid':
        return 'Bid Processed';
    case 'RemoveAuction':
        return 'Auction Removed';
    default:
        return value.type;
    }
};

export const divideNumbersLetters = (value) => {
    const patt1 = /[0-9]/g;
    const patt2 = /[a-zA-Z]/g;
    const letters = value.match(patt2);
    const digits = value.match(patt1);

    return {
        digits: digits.join(''),
        letters: letters.join(''),
    };
};

export const getWrapAddress = (string, limit, endLimit = 6) => {
    const dots = '...';
    if (string && string.length > limit) {
        string = string.substring(0, limit) + dots + string.slice(string.length - endLimit, string.length);
    }

    return string;
};

export const getProposalType = (type) => {
    switch (type) {
    case '/cosmos.upgrade.v1beta1.SoftwareUpgradeProposal':
        return 'Software Upgrade';
    case '/cosmos.gov.v1beta1.TextProposal':
        return 'Text';
    case '/cosmos.params.v1beta1.ParameterChangeProposal':
        return 'Parameter Change';
    case '/ibc.core.client.v1.ClientUpdateProposal':
        return 'IBC Client Update';
    case '/cosmos.distribution.v1beta1.MsgCommunityPoolSpend':
        return 'Community Pool';
    case '/cosmwasm.wasm.v1.MsgStoreCode':
        return 'Store Code';
    case '/cosmwasm.wasm.v1.MsgUpdateParams':
        return 'Update Params';
    default: {
        const typeSplit = type && type.split('.');
        if (typeSplit && typeSplit.length) {
            return typeSplit[typeSplit.length - 1];
        } else {
            return type;
        }
    }
    }
};

export const generateRandomNumber = (salt) => {
    const uniqueId = Date.now().toString();
    const inputString = salt + uniqueId;

    // Generate a SHA-256 hash
    const hash = crypto.createHash('sha256').update(inputString).digest('hex');

    // Convert the hash to binary
    const binaryString = BigInt(`0x${hash}`).toString(2);

    // Limit the binary length (e.g., first 8 bits or desired length)
    const limitedBinaryString = binaryString.slice(0, 8);

    return limitedBinaryString;
};

export const getRemainingTime = (endTime, fullText) => {
    const now = new Date().getTime();
    const distance = new Date(endTime).getTime() - now;

    if (distance <= 0) {
        return ('Time Ended');
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    if (fullText) {
        const dayString = days === 1 ? `${days}day ` : days > 0 ? `${days}days ` : '';
        const hourString = hours === 1 ? `${hours}hr ` : hours > 0 ? `${hours}hrs ` : days > 0 ? '00hrs ' : '';
        const minuteString = minutes === 1 ? `${minutes}min ` : minutes > 0 ? `${minutes}mins ` : hours > 0 ? '00mins ' : '';
        const secondString = seconds === 1 ? `${seconds}sec` : seconds > 0 ? `${seconds}secs` : '00secs';

        return (`${dayString}${hourString}${minuteString}${secondString}`);
    }

    const dayString = days > 0 ? `${days}d ` : '';
    const hourString = hours > 0 ? `${hours}h ` : days > 0 ? '00h ' : '';
    const minuteString = minutes > 0 ? `${minutes}m ` : hours > 0 ? '00m ' : '';
    const secondString = seconds > 0 ? `${seconds}s` : '00s';

    return (`${dayString}${hourString}${minuteString}${secondString}`);
};

export const getChannelMigrationStatusMessage = (value) => {
    const stages = value?.stages;
    const status = value?.status;
    const currentStatus = value?.current_status;

    if (status === 'FAILED' && currentStatus) {
        let key = currentStatus;
        if (key.endsWith('_FAILED')) {
            key = key.replace('_FAILED', '');
        } else if (key.endsWith('_IN_PROGRESS')) {
            key = key.replace('_IN_PROGRESS', '');
        }
        key = key.toLowerCase();

        const label = migrationStages[key] || key;
        return `${label} Failed. `;
    }

    for (const key of migrationStagesOrder) {
        if (stages && stages[key] === 'IN_PROGRESS') {
            return `${migrationStages[key]} is In Progress`;
        }
    }

    for (let i = migrationStagesOrder.length - 1; i >= 0; i--) {
        const key = migrationStagesOrder[i];
        if (stages && stages[key] === 'COMPLETED') {
            return `${migrationStages[key]} Completed`;
        }
    }

    return 'Migration will begin shortly. ';
};

export const truncateMiddle = (str, visibleChars) => {
    const totalVisible = visibleChars * 2;
    if (str.length <= totalVisible) { return str; }
    return str.slice(0, visibleChars) + '...' + str.slice(-visibleChars);
};

export const getByteLength = (str) => new TextEncoder().encode(str).length;
